import apiClient from './apiClient';

/**
 * Generate a client-side UUID used to make progress writes idempotent.
 * It is an idempotency key, not an authentication credential.
 */
export function generateClientUUID() {
  const browserCrypto = typeof window !== 'undefined' ? window.crypto : null;

  if (browserCrypto?.randomUUID) {
    return browserCrypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (browserCrypto?.getRandomValues) {
    browserCrypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  // RFC 4122 version 4 / variant bits.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-');
}

export function isUserConnected() {
  return Boolean(localStorage.getItem('concours_bf_token'));
}

export function createQuizAttempt(payload) {
  return apiClient('/progress/quiz-attempts', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function gradeQuizAttempt(payload) {
  return apiClient('/content/grade/quiz', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function gradeSimulationAttempt(payload) {
  return apiClient('/content/grade/simulation', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}


export function createSimulationAttempt(payload) {
  return apiClient('/progress/simulation-attempts', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getQuizAttempts(limit = 50, offset = 0) {
  return apiClient(`/progress/quiz-attempts?limit=${limit}&offset=${offset}`);
}

export function getSimulationAttempts(limit = 50, offset = 0) {
  return apiClient(`/progress/simulation-attempts?limit=${limit}&offset=${offset}`);
}

export function getQuestionStates() {
  return apiClient('/progress/questions');
}

export function updateQuestionState(questionId, updates) {
  return apiClient(`/progress/questions/${encodeURIComponent(questionId)}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

export function getResourceStates() {
  return apiClient('/progress/resources');
}

export function updateResourceState(resourceId, updates) {
  return apiClient(`/progress/resources/${encodeURIComponent(resourceId)}`, {
    method: 'PATCH',
    body: JSON.stringify(updates),
  });
}

export function getProgressSummary() {
  return apiClient('/progress/summary');
}


export function importLocalHistory(entries) {
  return apiClient('/progress/import-local-history', {
    method: 'POST',
    body: JSON.stringify({ entries }),
  });
}

export function getProgressDashboard(limit = 100) {
  return apiClient(`/progress/dashboard?limit=${limit}`);
}

export function clearQuizHistory() {
  return apiClient('/progress/quiz-history', {
    method: 'DELETE',
  });
}
